<template>
    <div id="charter">
        <Banner title="學會章程" :breadcrumbs="breadcrumbs" type="society"></Banner>
        <div class="container learning">
            <div class="center_title">
                <Title en="Constitution" chtFirst="學會" chtSecond="章程" :center="true"></Title>
            </div>
            <section class="content">
                <div class="title">
                    第一章 總則
                    <span class="remark">103.11.09會員大會通過變更</span>
                </div>
                <div class="charter_span">
                    <span>第一條</span>
                    <span>本會名稱為中華民國視網膜醫學會(以下簡稱本會)</span>
                </div>
                <div class="charter_span">
                    <span>第二條</span> 本會為依法設立、非以營利為目的之社會團體
                </div>
                <div class="charter_subtitle">宗旨如下:</div>
                <div class="charter_span">一、整合視網膜醫學及研究服務人才，提昇國內醫療水準。</div>
                <div class="charter_span mb">二、促進學術合作，推動視網膜醫學之國際交流。</div>
                <div class="charter_span">
                    <span>第三條</span> 本會以全國行政區域為組織區域。
                </div>
                <div class="charter_span">
                    <span>第四條</span>
                    <span>
                        本會會址設於主管機關所在地區，並得報經主管機關核准設分支機構。
                        前項分支機構組織簡則由理事會擬訂，報請主管機關核准後行之。
                        會址及分支機構之地址於設置及變更時應函報主管機關核備。
                    </span>
                </div>
                <div class="charter_span">
                    <span>第五條</span>
                    <ul>
                        <li>本會之任務如下：</li>
                        <li>一、發行本國之視網膜醫學刊物。</li>
                        <li>二、舉辦有關視網膜醫學之學術演講及研討會。</li>
                        <li>三、提供主管機關有關視網膜醫學之專業知識及作業準則。</li>
                        <li>四、整合視網膜研究及提供臨床知識交流平台。</li>
                    </ul>
                </div>
                <div class="charter_span">
                    <span>第六條</span>
                    <span>本會之主管機關為內政部。目的事業主管機關依章程所訂宗旨、任務主要為行政院衛生署。本會之目的事業應受各該事業主。</span>
                </div>
                <div class="title">第二章 會員</div>
                <div class="charter_span">
                    <span>第七條</span>
                    <span>本會會員申請資格如下：</span>
                </div>
                <div class="charter_span">一、個人會員：凡贊同本會宗旨、年滿二十歲者，並符合以下兩類資格之一者。</div>
                <div class="charter_span">第一類：視網膜臨床專科醫師，請同時具備下列資格：</div>
                <div class="charter_span">1、凡在政府認可之國內外醫學院校畢業，並取得行政院衛生署核發之眼科專科醫師證書資格者。</div>
                <div class="charter_span mb">2、受過一年以上視網膜專科訓練，或經本會遴選委員會推薦者。</div>
                <div class="charter_span">第二類：醫學相關學術領域研究有成者，且具備下列資格之一：</div>
                <div class="charter_span mb">
                    <div>2、</div>
                    <div>
                        曾就讀於國內外大學，其學術論文與視網膜研究相關者。
                        上述兩類之申請者，申請時應填具入會申請書，由本會會員二人以上之介紹，經理事會審查通過，並繳納會費方可取得會員資格（其中
                        第二類會員尚須提出已出版之學術論文）。
                    </div>
                </div>
                <div class="charter_span">入會費：會員新台幣伍千元，準會員新台幣壹仟元，於入會時繳納。</div>
                <div class="charter_span mb">常年會費：會員新台幣壹仟元，準會員新台幣壹仟元。</div>
                <div class="charter_span">二、團體會員：凡贊同本會宗旨之公私機構或團體。</div>
                <div class="charter_span">三、贊助會員：贊助本會工作之團體或個人。</div>
                <div class="charter_span mb">申請時應填具入會申請書，經理事會通過，並繳納會費。</div>
                <div class="charter_span">
                    <span>第八條</span>
                    <span>個人會員有表決權、選舉權、被選舉權與罷免權；每一會員為一權。團體會員應推派代表一人（會員代表），以行使會員權利。贊助會員無前項權利。</span>
                </div>
                <div class="charter_span">
                    <span>第九條</span>
                    <span>會員有遵守本會章程、決議及繳納會費之義務。</span>
                </div>
                <div class="charter_span mb">
                    <span>第十條</span>
                    <span>會員（會員代表）有違反法令，章程或不遵守會員大會決議時，得經理事會決議，予以警告或停權處分，其危害團體情節重大者，得經會員（會員代表）大會決議予以除名。</span>
                </div>
                <div
                    class="charter_span"
                >停權及解除會籍：本會會員若有違反法令、章程、妨害本會名譽、不履行會員義務或不遵守理事會決議及會員大會決議時，得經理事會決議，予以警告或停權處分，其危害團體情節重大者，經理事會調查屬實，得經會員(會員代表)大會決議予以除名。會員之停權處分，對妨害其他會員之權益或理事會之決議者，可處以半年以上二年以內之停權處分。（以上停權處份不需經過會員大會之議決）處分辦法：</div>
                <div class="charter_span">會員或準會員有違反下列各款情事屬實者，依情節輕重分別予以警告、停權、除名之處分。</div>
                <div class="charter_span">違反政府法規，經司法機關判決確定且經理事會議決者。</div>
                <div class="charter_span">違反本會章程規定，不履行會員義務，經查明屬實者。</div>
                <div class="charter_span">違反醫師法，以不當廣告或不當宣傳手法，妨害本學會名譽者。</div>
                <div class="charter_span">以未經查證之虛假情事，對本會作攻擊者。</div>
                <div class="charter_span">二年（含）以上不繳會費，經催繳二次仍未繳交者，予以停權處分。</div>
                <div class="charter_span">三年（含）以上不繳會費，經催繳二次仍未繳交者，予以除名處分。</div>
                <div class="charter_span">被處分之會員或準會員有向理事會提出申辯之權利。</div>
                <div class="charter_span">恢復會籍：凡經除名之會員滿一年後，可向理事會提出重</div>
                <div class="title">第三章 組織及職權</div>
                <div class="charter_span">
                    <span>第十三條</span>
                    <span>
                        本會以會員大會為最高權力機構。會員(會員代表)人數超過三百人以上時得分區比例選出會員代表，再召開會員代表大會，
                        行使會員大會職權。會員代表任期二年，其名額及選舉辦法由理事會擬訂，報請主管機關核備後行之。
                    </span>
                </div>
                <div class="charter_span">
                    <span>第十四條</span>
                    <span>會員大會之職權如下：</span>
                </div>
                <div class="charter_span">一、訂定與變更章程。</div>
                <div class="charter_span">二、選舉及罷免理事、監事。</div>
                <div class="charter_span">三、議決入會費、常年會費、事業費及會員捐款之數額及方式。</div>
                <div class="charter_span">四、議決年度工作計畫、報告及預算、決算。</div>
                <div class="charter_span">五、議決會員（會員代表）之除名處分。</div>
                <div class="charter_span">六、議決財產之處分。</div>
                <div class="charter_span">七、議決本會之解散。</div>
                <div class="charter_span">八、議決與會員權利義務有關之其他重大事項。</div>
                <div class="charter_span mb">前項第八款重大事項之範圍由理事會定之。</div>
                <div class="charter_span">
                    <span>第十五條</span>
                    <span>本會置理事15人、監事5人，由會員（會員代表）選舉之，分別成立理事會、監事會。</span>
                </div>
                <div
                    class="charter_span"
                >選舉前項理事、監事時，依計票情形得同時選出候補理事3人，候補監事1人，遇理事、監事出缺時，分別依序遞補之。本屆理事會得提出下屆理事、監事候選人參考名單。</div>
                <div class="charter_span">理事、監事得採用通訊選舉，但不得連續辦理。通訊選舉辦法由理事會通過，報請主管機關核備後行之。</div>
                <div class="charter_span">
                    <span>第十六條</span>
                    <span>理事會之職權如下：</span>
                </div>
                <div class="charter_span">一、審定會員（會員代表）之資格。</div>
                <div class="charter_span">二、選舉及罷免常務理事、理事長。</div>
                <div class="charter_span">三、議決理事、常務理事及理事長之辭職。</div>
                <div class="charter_span">四、聘免工作人員。</div>
                <div class="charter_span">五、擬訂年度工作計畫、報告及預算、決算。</div>
                <div class="charter_span mb">六、其他應執行事項。</div>
                <div class="charter_span mb">
                    <span>第十七條</span>
                    <span>理事會置常務理事5人，由理事互選之，並由理事就常務理事中選舉一人為理事長。理事長對內綜理督導會務，對外代表本會，並擔任會員大會、理事會主席。理事長因事不能執行職務時，應指定常務理事一人代理之。未指定或不能指定時，由常務理事互推一人代理之。理事長、常務理事出缺時，應於一個月內補選之。</span>
                </div>
                <div class="charter_span">
                    <span>第十八條</span>
                    <span>監事會之職權如下</span>
                </div>
                <div class="charter_span">一、監察理事會工作之執行。</div>
                <div class="charter_span">二、審核年度決算。</div>
                <div class="charter_span">三、選舉及罷免常務監事。</div>
                <div class="charter_span">四、議決監事及常務監事之辭職。</div>
                <div class="charter_span mb">五、其他應監察事項。</div>
                <div class="charter_span">
                    <span>第十九條</span>
                    <span>監事會置常務監事一人，由監事互選之，監察日常會務，並擔任監事會主席。常務監事因事不能執行職務時，應指定監事一人代理之，未指定或不能指定時，由監事互推一人代理之。監事會主席（常務監事）出缺時，應於一個月內補選之。</span>
                </div>
                <div class="charter_span">
                    <span>第二十條</span>
                    <span>監事會之理事、監事均為無給職，任期二年，連選得連任。理事長任期二年，得連任一次。理事、監事任期自召開本屆第一次理事會之日起計算。職權如下</span>
                </div>
                <div class="charter_span">
                    <span>第二十一條</span>
                    <span>理事、監事有下列情事之一者，應即解任：</span>
                </div>
                <div class="charter_span">一、喪失會員（會員代表）資格者。</div>
                <div class="charter_span">二、因故辭職經理事會或監事會決議通過者。</div>
                <div class="charter_span">三、被罷免或撤免者。</div>
                <div class="charter_span mb">四、受停權處分期間逾任期二分之一者。</div>
                <div class="charter_span">
                    <span>第二十二條</span>
                    <span>本會置秘書長一人，承理事長之命處理本會事務，其他工作人員若干人，由理事長提名經理事會通過聘免之，並報主管機關備查。</span>
                </div>
                <div class="charter_span">秘書長(或副秘書長)應列席理事會。</div>
                <div class="charter_span">工作人員權責及分層負責事項由理事會另定之。</div>
                <div class="charter_span">前項工作人員不得由理事、監事擔任。</div>
                <div class="charter_span">
                    <span>第二十三條</span>
                    <span>本會得設各種委員會、小組或其他內部作業組織，其組織簡則經理事會通過後施行，變更時亦同。</span>
                </div>
                <div class="title">第四章 會議</div>
                <div class="charter_span">
                    <span>第二十四條</span>
                    <span>會員大會分定期會議與臨時會議二種，由理事長召集，召集時除緊急事故之臨時會議外應於十五日前以書面通知之。定期會議每年召開一次，臨時會議於理事會認為必要，或經會員（會員代表）五分之一以上之請求，或監事會函請召集時召開之。本會辦理法人登記後，臨時會議經會員（會員代表）十分之一以上之請求召開之。</span>
                </div>
                <div class="charter_span">
                    <span>第二十五條</span>
                    <span>會員（會員代表）不能親自出席會員大會時，得以書面委託其他會員（會員代表）代理，每一會員（會員代表）以代理一人為限。</span>
                </div>
                <div class="charter_span mb">
                    <span>第二十六條</span>
                    <span>會員（會員代表）大會之決議，以會員（會員代表）過半數之出席，出席人數較多數之同意行之。但章程之訂定與變更、會員（會員代表）之除名、理事及監事之罷免、財產之處分、本會之解散及其他與會員權利義務有關之重大事項應有出席人數三分之二以上同意。</span>
                </div>
                <div
                    class="charter_span mb"
                >本會辦理法人登記後，章程之變更以出席人數四分之三以上之同意或全體會員三分之二以上書面之同意行之。本會之解散，得隨時以全體會員三分之二以上之可決解散之。</div>
                <div class="charter_span">
                    <span>第二十七條</span>
                    <span>理事會、監事會每四個月各舉行會議一次，必要時得召開聯席會議或臨時會議。前項會議召集時除臨時會議外，應於七日前以書面通知。會議之決議，各以理事、監事過半數之出席，出席人數較多數之同意行之。</span>
                </div>
                <div class="charter_span">
                    <span>第二十八條</span>
                    <span>理事應出席理事會議，監事應出席監事會議，不得委託出席; 理事、監事連續二次無故缺席理事會、監事會者，視同辭職。</span>
                </div>
                <div class="title">第五章 經費及會計</div>
                <div class="charter_span">
                    <span>第二十九條</span>
                    <span>本會經費來源如下:</span>
                </div>
                <div class="charter_span">一、入會費：個人會員新台幣伍仟元，於會員入會時繳納。</div>
                <div class="charter_span">二、常年會費：個人會員新台幣壹仟元。</div>
                <div class="charter_span">三、事業費。</div>
                <div class="charter_span">四、會員捐款。</div>
                <div class="charter_span">五、委託收益。</div>
                <div class="charter_span">六、基金及其孳息。</div>
                <div class="charter_span mb">七、其他收入。</div>
                <div class="charter_span">
                    <span>第三十條</span>
                    <span>本會會計年度以曆年為準，自每年一月一日起至十二月三十一日止。</span>
                </div>
                <div class="charter_span">
                    <span>第三十一條</span>
                    <span>
                        本會每年於會計年度開始前二個月由理事會編造年度工作計畫、收支預算表、員工待遇表，提會員大會通過（會員大會因故未能如 期召開者，先提理監事聯席會議通過），於會計年度開始前報主管機關核備。並於會計年度終了後二個月內由理
                        事會編造年度工作報告、收支決算表、現金出納表、資產負債表、財產目錄及基金收支表，送監事會審核後，造具審核意見書送還理事會，提會員大會通過，於三月底前報主管機關核備（會員大會未能如期召開者，先報主管機關。）
                    </span>
                </div>
                <div class="charter_span">
                    <span>第三十二條</span>
                    <span>本會解散後，剩餘財產歸屬所在地之地方自治團體或主管機關指定之機關團體所有。</span>
                </div>
                <div class="title">第六章 附則</div>
                <div class="charter_span mb">
                    <span>第三十三條</span>
                    <ul>
                        <li>1、資格：領有醫師證書，並從事眼科醫療工作者，經本會會員二人之介紹經理事會通過後即為本會準會員。</li>
                        <li>2、權利：準會員可參加各項學術研究活動，但無表決權、選舉權、被選舉權、罷免權。</li>
                        <li>3、義務與除名：準會員之義務與除名，與會員相同。</li>
                    </ul>
                </div>
                <div class="charter_span">
                    <span>第三十四條</span>
                    <span>本章程未規定事項，悉依有關法令規定辦理。</span>
                </div>
                <div class="charter_span">
                    <span>第三十五條</span>
                    <span>本章程經會員（會員代表）大會通過，報經主管機關核備後施行，變更時亦同。</span>
                </div>
                <div class="charter_span">
                    <span>第三十六條</span>
                    <span>本章程經本會中華民國101年1月8日第一屆第一次會員大會通過。</span>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import Banner from "@/components/banner";
import Title from "@/components/Title";
export default {
    name: "charter",
    components: {
        Title,
        Banner
    },
    props: {},
    data() {
        return {
            breadcrumbs: [
                {
                    url: "/",
                    title: "首頁"
                },
                {
                    title: "學會簡介"
                },
                {
                    url: "/Society/Chapter",
                    title: "學會章程"
                }
            ]
        };
    },
    methods: {},
    computed: {},
    created() {},
    mounted() {},
    watch: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#charter .content .title .remark {
    display: inline-block;
    text-align: center;
    width: 100%;
    margin: auto;
    padding: 0;
    font-size: 0.6rem;
    color: #666;
    font-weight: normal;
}
#charter .content .charter_span {
    display: flex;
    padding: 3px 0;
    /* align-items: center; */
}
#charter .content .charter_subtitle {
    font-size: 24px;
    font-weight: 600;
    padding: 20px 0 15px;
}
#charter .content .charter_span.mb {
    margin-bottom: 25px;
}
#charter .content .charter_span span {
    min-width: 100px;
}
</style>



// WEBPACK FOOTER //
// src/pages/charter.vue